<template>
  <div>
    <template v-for="(field, index) in field_list">
      <template v-if="repeatField(field.rules)">
        <transition-group name="fade">
          <form-item v-for="n in repeatField(field.rules)"
            v-if="showField(field.rules)"
            :type="field.type"
            :name="field.name"
            :title="field.title"
            :data="field.data"
            :key="n"
            :repeat="true"
            v-model="field_list[index].value">
          </form-item>
        </transition-group>
      </template>
      <template v-else>
        <transition name="fade">
          <form-item
              v-if="showField(field.rules)"
              :type="field.type"
              :name="field.name"
              :title="field.title"
              :data="field.data"
              v-model="field_list[index].value">
          </form-item>
        </transition>
      </template>
    </template>

    <div class="error-container" v-show="field_errors.length > 0">
      <p class="error" v-for="field in field_errors">{{ $t('form.error_blank', { field: field.title }) }}</p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FormItem from './form-item.vue';
  // import _ from 'lodash';

  export default {
    data () {
      return {
        form: null
      };
    },

    components: {
      FormItem
    },

    computed: {
      ...mapGetters([
        'active_module',
        'fields',
        'field_errors'
      ]),

      field_list () {
        return this.active_module.fields;
      },

      testShow () {
        return this.showField(this.field_list[5].rules);
      },

      testRepeat () {
        return this.repeatField(this.field_list[5].rules);
      }
    },

    methods: {
      repeatField (terms) {
        if (!terms.length) return 0;

        return (terms.map(({action}) => {
          let args = this.getArguments(action);
          if (args[0] !== 'REPEAT_FIELD') return 0;

          return parseInt(this.findField(args[1]).value) || 0;
        })).reduce((a, b) => {
          return a + b;
        });
      },

      showField (terms) {
        if (!terms.length) return true;

        return (terms.map(({rules, action, logic_mode}) => {
          let args = this.getArguments(action);
          let resp = args[0] !== 'HIDE_FIELD';

          let test = rules.length ? (rules.map((rule) => {
            return this.testRule(rule);
          })).reduce((a, b) => {
            return logic_mode === 'ALL' ? a && b : a || b;
          }) : true;

          return test ? resp : !resp;
        })).reduce((a, b) => {
          return a && b;
        });
      },

      testRule (rule) {
        let args = this.getArguments(rule);
        let operand1 = this.findField(args[0]);
        let operand2 = args[2] === 'OTHER_FIELD_VALUE' ? this.findField(args[3]).value : args[3];

        switch (args[1]) {
          case 'NOT_EMPTY':
            return operand1.value.trim() !== '';
          case 'EMPTY':
            return operand1.value.trim() === '';
          case 'EQUAL':
            return operand1.value === operand2;
          case 'NOT_EQUAL':
            return operand1.value !== operand2;
          case 'GREATER_THAN':
            return operand1.value > operand2;
          case 'LESS_THAN':
            return operand1.value < operand2;
        }
      },

      findField (id) {
        return this.field_list.find((f) => {
          return f.field_id === parseInt(id);
        });
      },

      getArguments (data) {
        return data.split(':');
      }
    }
  };

</script>

<style scoped>
  .error-container {
    padding: 20px;
    margin-bottom: 20px;
    border: 2px solid red;
  }

  .error-container .error {
    font-weight: 700;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// FormList.vue?0c3b5632